module.exports = __webpack_public_path__ + "static/media/vcc.6e3262a3.png";